import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=de4cb266&"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=de4cb266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports